// extracted by mini-css-extract-plugin
module.exports = {"dial":"e_Cwb"};